import { AxiosError } from 'axios';
import environment from '../../../../environments/environment';
import { axiosInterceptor } from '../authInterceptor';

interface CheckingFilter{
  participantId:number,
  isActive: string, 
  page: number,
  size: number
}
interface NotesVO{
  dnlDesc: string,
}

interface CheckVo{
  accountNumber: string,
  x9FilePath: any,
  checkNumber: string,
  routingNumber: string,
  view: string
}

export async function getAssetSummaryByPId(participantId: number, clientId: number) {
  try {
    const resAssetSummaryByPId = await axiosInterceptor.get(
      `${environment.assetSummaryByPID}${participantId}?clientId=${clientId}`
    );
    return resAssetSummaryByPId;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getLoanSummaryByPId(participantId:number, clientId: number) {
  try{
    const resLoanSummaryByPId= await axiosInterceptor.get(`${environment.loanSummaryByPID}${participantId}?clientId=${clientId}`); 
    return resLoanSummaryByPId;
  } catch (error: any) { 
    return error;
  }
} 

export async function getCapitalSummaryByPId(participantId:number, clientId: number) {
  try{
    const resCaptialSummaryByPId= await axiosInterceptor.get(`${environment.capitalSummaryByPID}${participantId}?clientId=${clientId}`); 
    return resCaptialSummaryByPId;
  } catch (error: any) { 
    return error;
  }
} 

export async function getExpensesSummaryByPId(participantId:number, clientId: number) {
  try{
    const resExpensesSummaryByPId= await axiosInterceptor.get(`${environment.expensesSummaryByPID}${participantId}?clientId=${clientId}`); 
    return resExpensesSummaryByPId;
  } catch (error: any) { 
    return error;
  }
}
export async function getRCBOAssetSummary(clientId: number) {
  try{
    const resAssetSummaryByPId= await axiosInterceptor.get(`${environment.assetRCBOSummary}?clientId=${clientId}`); 
    return resAssetSummaryByPId;
  } catch (error: any) { 
    return error;
  }
} 

export async function getRCBOLoanSummary(clientId: number) {
  try{
    const resLoanRcboSummary= await axiosInterceptor.get(`${environment.loanRcboSummary}?clientId=${clientId}`); 
    return resLoanRcboSummary;
  } catch (error: any) { 
    return error;
  }
} 

export async function getCapitalRCBOSummary(clientId: number) {
  try{
    const resCaptialRcboSummary= await axiosInterceptor.get(`${environment.capitalRcboSummary}?clientId=${clientId}`); 
    return resCaptialRcboSummary;
  } catch (error: any) { 
    return error;
  }
} 

export async function getExpensesRCBOSummary(clientId: number) {
  try{
    const resExpensesRcboSummary= await axiosInterceptor.get(`${environment.expensesSummary}?clientId=${clientId}`); 
    return resExpensesRcboSummary;
  } catch (error: any) { 
    return error;
  }
}

export async function getBankSummaryByPId(participantId:number, clientId: number) {
   
  try {
    const resBankSummaryByPId = await axiosInterceptor.get(`${environment.bankDetailsSummaryByPidURL}${participantId}?clientId=${clientId}`);
    return resBankSummaryByPId;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
} 

export async function getAccountSummaryByRAN(routingNumber: string,accountNumber: string, clientId: number) {
  try {
    const resAssetSummaryByPId = await axiosInterceptor.get(
      `${environment.transactionSummaryDetailsURL}${routingNumber}/${accountNumber}?clientId=${clientId}`
    );
    return resAssetSummaryByPId;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
}


export async function getPreviousMonthList(participantId: number,clientId: number) {
  try {
    const resMonthlyList = await axiosInterceptor.get(`${environment.getListOfPreviousMonthsURL}participant/${participantId}?clientId=${clientId}`);
    return resMonthlyList;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getMasterTransactionFilter(checkingFilter: CheckingFilter) {
  try {
    const resMasterTransctionList = await axiosInterceptor.post(`${environment.getMasterTransactionURL}`,checkingFilter);
    return resMasterTransctionList;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function patchMasterTransactionNotes(masterTransactionId: number, notesVO: NotesVO) {
  try {
    const resMasterTransNotes = await axiosInterceptor.patch(`${environment.masterTransNotesURL}${masterTransactionId}`,notesVO);
    return resMasterTransNotes;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getCheckImage(checkImageVO: CheckVo) {
  try {
    const resCheckImage = await axiosInterceptor.post(`${environment.getCheckImageDigerTech}`,checkImageVO);
    return resCheckImage;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
}

export async function getDownloadMasterTransaction(downloadFilter: any) {
  try {
    const resDownloadFormat = await axiosInterceptor.post(`${environment.downloadFileURL}`,downloadFilter);
    return resDownloadFormat;
  } catch (error: any) {
    if (error instanceof AxiosError) { 
      throw error; 
    }
    throw new Error("Unexpected error occurred");
  }
}